import { handleLogin } from "utils/base"

const LoginOnlive = () => {
  return (
    <div className="">
      <button
        className=""
        onClick={() => {
          handleLogin({ redirectUrl: process.env.NEXT_PUBLIC_REDIRECT_URL })
        }}
      >
        <img src="/images/onlive.png" alt="" />
      </button>
    </div>
  )
}

export default LoginOnlive
